export default "skymp5-front/5e164cbc60be2f15cb44506e57059829.jpg";